import axios from './axios';
import SETTINGS from '../settings'
export default {
    getComments(params, cb) {
        axios.get(`${SETTINGS.API_BASE_PATH}/contentcomment`, {
            params: params
        }).then(response => {
            cb(response.data)
        }).catch(e => {
            console.log(e)
        })
    },
    addComment(payload, cb) {
        axios.post(`${SETTINGS.API_BASE_PATH}/contentcomment`, payload).then(response => {
            cb(response.data)
        }).catch(e => {
            cb(e)
        })
    }
}